import React from 'react';
import { Helmet } from 'react-helmet';

const PricingPage = () => {
  return (
    <div style={containerStyle}>
      {/* Helmet for setting the page title and meta description */}
      <Helmet>
        <title>Pricing | SMS Textr</title>
        <meta name="description" content="Explore the pay-as-you-go pricing plans for SMS Textr. Purchase SMS credits at flexible rates for your business and development needs." />
        <meta name="keywords" content="SMS Textr, SMS API, SMS pricing, pay-as-you-go SMS, SMS service, affordable SMS API, send SMS USA, send SMS Canada, SMS for developers, SMS for business, bulk SMS API, SMS pricing plan, North America SMS API" />
        <meta name="author" content="SMS Textr Team" />
      </Helmet>
      <h1 style={headerStyle}>Pay As You Go Pricing</h1>
      <p style={subHeaderStyle}>Purchase credits for SMS text messages</p>
      
      <div style={plansContainerStyle}>
        <div style={planStyle}>
          <h2 style={planTitleStyle}>Starter</h2>
          <p style={priceStyle}>$3</p>
          <p style={smsCountStyle}>50 SMS Credits</p>
        </div>
        
        <div style={planStyle}>
          <h2 style={planTitleStyle}>Basic</h2>
          <p style={priceStyle}>$10</p>
          <p style={smsCountStyle}>250 SMS Credits</p>
        </div>

        <div style={planStyle}>
          <h2 style={planTitleStyle}>Pro</h2>
          <p style={priceStyle}>$30</p>
          <p style={smsCountStyle}>1000 SMS Credits</p>
        </div>

        <div style={planStyle}>
          <h2 style={planTitleStyle}>Enterprise</h2>
          <p style={priceStyle}>$50</p>
          <p style={smsCountStyle}>2500 SMS Credits</p>
        </div>

        <div style={planStyle}>
          <h2 style={planTitleStyle}>Custom</h2>
          <p style={priceStyle}>
            <a href="mailto:smstextr@gmail.com" style={contactLinkStyle}>Contact Sales</a>
          </p>
          <p style={smsCountStyle}>Tailored to Your Needs</p>
        </div>
      </div>

      <button style={buttonStyle} onClick={() => window.location.href = '/login'}>Login to Buy Credits</button>
      <button style={buttonStyle} onClick={() => window.location.href = '/regions'}>View SMS Credits by Country</button>
      
      <p style={disclaimerStyle}>
        Credit cards are processed by Stripe and are not stored on our servers. 
        This is a one-time charge. By purchasing you are bound by our Terms of Service.
      </p>
    </div>
  );
};

// Inline CSS styles
const containerStyle = {
backgroundColor: '#f0f0f0',  
  padding: '20px',
  textAlign: 'center',
};

const headerStyle = {
  fontSize: '32px',
  color: '#333',
  marginBottom: '10px',
};

const subHeaderStyle = {
  fontSize: '18px',
  color: '#555',
  marginBottom: '20px',
};

const plansContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '15px',
  marginBottom: '20px',
};

const planStyle = {
  border: '1px solid #ddd',
  padding: '15px',
  width: '180px',
  textAlign: 'center',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: '#f8f9fa',
};

const planTitleStyle = {
  fontSize: '20px',
  color: '#333',
  marginBottom: '5px',
};

const priceStyle = {
  fontSize: '28px',
  color: '#28a745',
  margin: '10px 0',
  fontWeight: 'bold',
};

const smsCountStyle = {
  fontSize: '16px',
  color: '#555',
  margin: '5px 0',
  backgroundColor: '#e9ecef',
  padding: '3px 8px',
  borderRadius: '20px',
  display: 'inline-block',
};

const buttonStyle = { 
  backgroundColor: '#28a745',
  color: 'white',
  padding: '10px 20px',
  borderRadius: '5px',
  textDecoration: 'none',
  fontWeight: 'bold',
  marginRight: '10px',
  border: 'none',  // Remove default border
  outline: 'none', // Remove focus outline
  boxShadow: 'none' // Remove any default shadow
};

const disclaimerStyle = {
  fontSize: '12px',
  color: '#777',
  maxWidth: '600px',
  margin: '0 auto',
};

const contactLinkStyle = {
  color: '#007bff',
  textDecoration: 'none',
  fontWeight: 'bold',
  marginLeft: '5px',
};
  
export default PricingPage;
